import { Injectable } from "@angular/core";
import { RestService } from ".";

@Injectable()
export class CompanyService {
    constructor(private restService: RestService) { }

    getCompanyDetails() {
        return this.restService.getData('company');
    }
}